import { Tab } from "@lg-cfa/components";
import { ButtonTypes } from "@lg-cfa/enums";
import { PageInterface } from "@lg-cfa/types";

import currentCar from "@assets/icons/car-tangerine.svg";
import newCar from "@assets/icons/new-car-tangerine.svg";
import secondhandCar from "@assets/icons/second-hand-car-tangerine.svg";
import { DataFields, GetTariffParameterObjectCarType, PageNames } from "@enums";

export const tabs: Tab[] = [
    {
        value: "1",
        label: "stepper.step1",
        name: PageNames.CarType,
    },
    {
        value: "2",
        label: "stepper.step2",
        name: PageNames.DriverInformation,
    },
    {
        value: "3",
        label: "stepper.step3",
        name: PageNames.InsuranceChoice,
    },
    {
        value: "4",
        label: "stepper.step4",
        name: PageNames.BrokerSearch,
    },
    {
        value: "5",
        label: "stepper.step5",
        name: PageNames.BrokerSearch,
    },
];

export const pagesArray: PageInterface[] = [
    {
        name: PageNames.Welcome,
        cy: "welcome-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/start-1"
                : "/commencez-1",
        prevPage: undefined,
        isPrevPageExternal: false,
        nextPage: PageNames.CarType,
        isNextPageExternal: false,
        testTag: "lg-car-welcome",
        buttons: {
            prev: {
                text: "",
                type: undefined,
            },
            next: {
                text: "steppernavigation.start",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "",
        neededData: [],
        weTakeCareData: [],
    },
    {
        name: PageNames.CarType,
        cy: "car-type-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/keuze-2"
                : "/choix-2",
        prevPage: PageNames.Welcome,
        isPrevPageExternal: false,
        nextPage: PageNames.CarDescription,
        isNextPageExternal: false,
        testTag: "lg-car-type",
        buttons: {
            prev: {
                text: "steppernavigation.previous",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.next",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "1",
        neededData: [],
        weTakeCareData: [],
    },
    {
        name: PageNames.CarDescription,
        cy: "car-description-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/type-3"
                : "/type-3",
        prevPage: PageNames.CarType,
        isPrevPageExternal: false,
        nextPage: PageNames.CarDetails,
        isNextPageExternal: false,
        testTag: "lg-car-description",
        buttons: {
            prev: {
                text: "steppernavigation.previous",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.next",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "1",
        neededData: [DataFields.carType],
        weTakeCareData: [],
    },
    {
        name: PageNames.CarDetails,
        cy: "car-details-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/km-opties-4"
                : "/km-options-4",
        prevPage: PageNames.CarDescription,
        isPrevPageExternal: false,
        nextPage: PageNames.DriverInformation,
        isNextPageExternal: false,
        testTag: "lg-car-details",
        buttons: {
            prev: {
                text: "steppernavigation.previous",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.next",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "1",
        neededData: [
            DataFields.carType,
            DataFields.carDescriptionMake,
            DataFields.carDescriptionModel,
            DataFields.carDescriptionFuel,
            DataFields.carDescriptionPower,
            DataFields.carDescriptionVehicleType,
        ],
        weTakeCareData: [],
    },
    {
        name: PageNames.DriverInformation,
        cy: "driver-information-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/bestuurder-5"
                : "/conducteur-5",
        prevPage: PageNames.CarDetails,
        isPrevPageExternal: false,
        nextPage: PageNames.DriverHistory,
        isNextPageExternal: false,
        testTag: "lg-car-driver-information",
        buttons: {
            prev: {
                text: "steppernavigation.previous",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.next",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "2",
        neededData: [
            DataFields.carType,
            DataFields.carDescriptionMake,
            DataFields.carDescriptionModel,
            DataFields.carDescriptionFuel,
            DataFields.carDescriptionPower,
            DataFields.carDescriptionVehicleType,
            DataFields.carDetailsMileage,
        ],
        weTakeCareData: [],
    },
    {
        name: PageNames.DriverHistory,
        cy: "driver-history-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/historiek-6"
                : "/historique-6",
        prevPage: PageNames.DriverInformation,
        isPrevPageExternal: false,
        nextPage: PageNames.InsuranceChoice,
        isNextPageExternal: false,
        testTag: "lg-car-driver-history",
        buttons: {
            prev: {
                text: "steppernavigation.previous",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.next",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "2",
        neededData: [
            DataFields.carType,
            DataFields.carDescriptionMake,
            DataFields.carDescriptionModel,
            DataFields.carDescriptionFuel,
            DataFields.carDescriptionPower,
            DataFields.carDescriptionVehicleType,
            DataFields.carDetailsMileage,
            DataFields.driverInformationBirthday,
            DataFields.driverInformationCity,
            DataFields.driverInformationPostalCode,
            DataFields.driverInformationStreet,
            DataFields.driverInformationNumber,
        ],
        weTakeCareData: [],
    },
    {
        name: PageNames.InsuranceChoice,
        cy: "insurance-choice-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/product-7"
                : "/produit-7",
        prevPage: PageNames.DriverHistory,
        isPrevPageExternal: false,
        nextPage: PageNames.AdditionalCovers,
        isNextPageExternal: false,
        testTag: "lg-car-select-insurance",
        buttons: {
            prev: {
                text: "steppernavigation.previous",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.next",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "3",
        neededData: [
            DataFields.carType,
            DataFields.carDescriptionMake,
            DataFields.carDescriptionModel,
            DataFields.carDescriptionFuel,
            DataFields.carDescriptionPower,
            DataFields.carDescriptionVehicleType,
            DataFields.carDetailsMileage,
            DataFields.driverInformationBirthday,
            DataFields.driverInformationCity,
            DataFields.driverInformationPostalCode,
            DataFields.driverInformationStreet,
            DataFields.driverInformationNumber,
            DataFields.driverHistory_License,
            DataFields.driverHistory_Insurance,
            DataFields.driverHistory_Accidents,
        ],
        weTakeCareData: [],
    },
    {
        name: PageNames.AdditionalCovers,
        cy: "additional-covers-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/extra-verzekeringen-8"
                : "/assurances-supplementaires-8",
        prevPage: PageNames.InsuranceChoice,
        isPrevPageExternal: false,
        nextPage: PageNames.BrokerSearch,
        isNextPageExternal: false,
        testTag: "lg-car-additional-covers",
        buttons: {
            prev: {
                text: "steppernavigation.previous",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.next",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "3",
        neededData: [
            DataFields.carType,
            DataFields.carDescriptionMake,
            DataFields.carDescriptionModel,
            DataFields.carDescriptionFuel,
            DataFields.carDescriptionPower,
            DataFields.carDescriptionVehicleType,
            DataFields.carDetailsMileage,
            DataFields.driverInformationBirthday,
            DataFields.driverInformationCity,
            DataFields.driverInformationPostalCode,
            DataFields.driverInformationStreet,
            DataFields.driverInformationNumber,
            DataFields.driverHistory_License,
            DataFields.driverHistory_Insurance,
            DataFields.driverHistory_Accidents,
            DataFields.insuranceChoice,
        ],
        weTakeCareData: [],
    },
    {
        name: PageNames.BrokerSearch,
        cy: "broker-search-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/makelaar-9"
                : "/courtier-9",
        prevPage: PageNames.AdditionalCovers,
        isPrevPageExternal: false,
        nextPage: PageNames.YourInformation,
        isNextPageExternal: false,
        testTag: "lg-car-broker-search",
        buttons: {
            prev: {
                text: "steppernavigation.previous",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.next",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "4",
        neededData: [
            DataFields.carType,
            DataFields.carDescriptionMake,
            DataFields.carDescriptionModel,
            DataFields.carDescriptionFuel,
            DataFields.carDescriptionPower,
            DataFields.carDescriptionVehicleType,
            DataFields.carDetailsMileage,
            DataFields.driverInformationBirthday,
            DataFields.driverInformationCity,
            DataFields.driverInformationPostalCode,
            DataFields.driverInformationStreet,
            DataFields.driverInformationNumber,
            DataFields.driverHistory_License,
            DataFields.driverHistory_Insurance,
            DataFields.driverHistory_Accidents,
            DataFields.insuranceChoice,
        ],
        weTakeCareData: [],
    },
    {
        name: PageNames.YourInformation,
        cy: "your-information-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/gegevens-10"
                : "/donnees-10",
        prevPage: PageNames.BrokerSearch,
        isPrevPageExternal: false,
        nextPage: PageNames.ThankYou,
        isNextPageExternal: false,
        testTag: "lg-car-your-information",
        buttons: {
            prev: {
                text: "steppernavigation.previous",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.confirm",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "5",
        neededData: [
            DataFields.carType,
            DataFields.carDescriptionMake,
            DataFields.carDescriptionModel,
            DataFields.carDescriptionFuel,
            DataFields.carDescriptionPower,
            DataFields.carDescriptionVehicleType,
            DataFields.carDetailsMileage,
            DataFields.driverInformationBirthday,
            DataFields.driverInformationCity,
            DataFields.driverInformationPostalCode,
            DataFields.driverInformationStreet,
            DataFields.driverInformationNumber,
            DataFields.driverHistory_License,
            DataFields.driverHistory_Insurance,
            DataFields.driverHistory_Accidents,
            DataFields.insuranceChoice,
        ],
        weTakeCareData: [],
    },
    {
        name: PageNames.ThankYou,
        cy: "thank-you-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/bedankt-11"
                : "/merci-11",
        prevPage: undefined,
        isPrevPageExternal: false,
        nextPage: "https://www.baloise.be/",
        isNextPageExternal: true,
        testTag: "lg-car-thank-you",
        buttons: {
            prev: {
                text: "",
                type: undefined,
            },
            next: {
                text: "steppernavigation.returntosite",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "",
        neededData: [DataFields.flowFinished],
        weTakeCareData: [DataFields.flowFinished],
    },
    {
        name: PageNames.TechnicalDifficulties,
        cy: "technical-difficulties-page",
        url:
            process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                ? "/simulatie-niet-beschikbaar"
                : "/simulation-non-disponible",
        prevPage: PageNames.Welcome,
        isPrevPageExternal: false,
        nextPage: PageNames.Welcome,
        isNextPageExternal: false,
        testTag: "lg-car-technical-difficulties",
        buttons: {
            prev: {
                text: "steppernavigation.tryagain",
                type: ButtonTypes.link,
                icon: "nav-go-left",
            },
            next: {
                text: "steppernavigation.returntostart",
                type: ButtonTypes.btnPrimary,
                iconRight: "nav-go-right",
            },
        },
        chapter: "",
        neededData: [],
        weTakeCareData: [],
    },
];

export const carTypeOptions = [
    {
        id: 1,
        title: "cartype.new",
        value: GetTariffParameterObjectCarType.NewCar,
        image: newCar,
        hint: "cartype.new.hint",
        testTag: "lg-new-car",
    },
    {
        id: 2,
        title: "cartype.current",
        value: GetTariffParameterObjectCarType.CurrentCar,
        image: currentCar,
        hint: "cartype.current.hint",
        testTag: "lg-current-car",
    },
    {
        id: 3,
        title: "cartype.secondhand",
        value: GetTariffParameterObjectCarType.SecondHandCar,
        image: secondhandCar,
        hint: "cartype.secondhandcar.hint",
        testTag: "lg-second-hand-car",
    },
];
